import { Button } from "@platform/ui-library";
import React from "react";
import ReactDOM from "react-dom";
import WorkerManager from "../utilities/workers/WorkerManager";
import { LoadingSpinner } from "./loading";
import LocaleTextarea from "./LocaleTextarea";

export default class UnusedPromptsNodeGroup extends React.Component {
    constructor(props) {
        super(props);
        this.dataCache = {
            unusedPrompts: this.props.unusedPrompts
        }
        this.state = {
            unusedPrompts: [],
            isFetchingUnusedPrompts: true
        }
        this.workers = new WorkerManager();
    }

    componentDidMount(){
        this.getUnusedPrompts();
    }

    setUnusedPrompts(unusedPrompts){
        this.setState({unusedPrompts: unusedPrompts});    
    }

    getUnusedPrompts(){
        this.setState({isFetchingUnusedPrompts: true});

        this.workers.postMessage("getUnusedPrompts", (data) => {
            this.setState({isFetchingUnusedPrompts: false})
            this.setUnusedPrompts(data.unusedPrompts);
        }, {serialized: this.props.serialized, unusedPrompts: []});
    }

    validateInput({ currentTarget }) {
        return currentTarget.value !== '';
    }

    getDomSelf() {
        return $(ReactDOM.findDOMNode(this));
    }

    setConfig(key, newValue) {
        if (key === "prompt") {
            const { lang, value, idx } = newValue;
            const prompt = this.props.unusedPrompts[idx];

            //update the components object
            let localUnusedPrompts= this.state.unusedPrompts;
            localUnusedPrompts[idx].props.config.text[lang] = newValue;
            this.setState({unusedPrompts: localUnusedPrompts});
            const componentsNode = window.apm.serialized.components.objects.filter(obj => obj.id === prompt.id)[0];
            componentsNode.props.config.text[lang] = value;
        }

        window.apm.setSerializedChanged();
        window.apm.postEventToCurrentView({ target: "request-refresh" });
        //window.apm.postEventToAllViews({target: "request-reload-data-model"});
    }

    getConfig(key) {
        return this.dataCache[key];
    }

    renderUnusedPrompts(){
        const unusedPromptsRows = this.state.unusedPrompts.map((rp, idx) => {
                return  <tr key={rp.id}>
                            <td><label>{rp.name!==""?rp.name:"Name is Empty"}</label></td>
                            <td>
                                <LocaleTextarea
                                    rowsVal={4}
                                    defaultValue={rp.props.config.text["en-US"]||""}
                                    valKey={"prompt"}
                                    idx={idx}
                                    context={this}
                                    type={"prompt"}
                                    language={this.props.language}
                                    isEnUS={true}
                                />
                            </td>
                            <td>
                                {this.props.language !== "en-US" &&
                                <LocaleTextarea
                                    rowsVal={4}
                                    defaultValue={rp.props.config.text[this.props.language] || ""}
                                    valKey={"prompt"}
                                    idx={idx}
                                    context={this}
                                    type={"prompt"}
                                    language={this.props.language}
                                    isEnUS={false}
                                />
                                }
                            </td>
                        </tr>
            });
        return unusedPromptsRows;
    }

    render() {
        var engSel = window.apm.knowledgeBase.getItemFromValue("en-US", window.apm.serialized.languages, "language");

        return (
            <div className="panel-group" role="tablist">
                <div className="panel panel-default">
                    <div className="panel-heading" role="tab" style={{ padding: "0", paddingLeft: "15px" }}>
                        <div className={"col-md-10"} style={{ padding: "10px" }}>
                            <div className="panel-title"
                                 onClick={() => {
                                     this.getDomSelf().find(".collapse[data-tracker='unused']").collapse('toggle');
                                 }}
                            >
                                <i className={"fe icon-link"} />
                                &nbsp;&nbsp;Unused Prompts
                            </div>
                        </div>
                        <div className={"col-md-2"} style={{ padding: "10px", textAlign: "right" }}>
                            <Button
                                disabled={this.state.isFetchingUnusedPrompts}
                                icon="refresh"
                                type="button"
                                theme="outlineHighlight"
                                onClick={() => this.getUnusedPrompts()}
                                title="Refresh unused prompts"
                            />
                        </div>
                    </div>
                    <div className="panel-collapse collapse in" role="tabpanel" data-tracker="unusedPrompts">
                        <div className="panel-body">
                            <div className="row">
                                <table className={"table table-condensed"}>
                                    <thead>
                                    <tr style={{ color: "var(--theme-text-muted)", fontSize: "14px" }}>
                                        <td style={{ width: "20%" }}>{window.l.settings.prompt_node_name}</td>
                                        <td style={{ width: "40%" }}>English - {engSel.voice}</td>
                                        {this.props.language !== "en-US" && <td style={{ width: "40%" }}>{this.props.language} - {this.props.voice}</td>}
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {this.state.isFetchingUnusedPrompts &&
                                        <tr>                                        
                                            <td colSpan="3">
                                                <LoadingSpinner message="Updating..." />
                                            </td>
                                        </tr>
                                    }

                                    {!this.state.isFetchingUnusedPrompts &&
                                        this.renderUnusedPrompts()
                                    }
                                    
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
